import { Timestamp } from 'firebase/firestore';
import { FirestoreEntity, Mapper } from '../../../@harmony';
import { DEFAULT_TEAM_PUBLIC_CACHE_SETTINGS } from '../../data/entities/team-settings';
import { TeamPublicCache } from '../models/team-public-cache.model';
import { TeamPublicCacheEntity } from '../..';

export class TeamPublicCacheToTeamPublicCacheEntityMapper
  implements Mapper<TeamPublicCache, FirestoreEntity<TeamPublicCacheEntity>>
{
  public map(from: TeamPublicCache): FirestoreEntity<TeamPublicCacheEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      updatedAt: Timestamp.fromDate(from.updatedAt),
      name: from.name,
      settings: from.settings,
    });
  }
}

export class TeamPublicCacheEntityToTeamPublicCacheMapper
  implements Mapper<FirestoreEntity<TeamPublicCacheEntity>, TeamPublicCache>
{
  public map(from: FirestoreEntity<TeamPublicCacheEntity>): TeamPublicCache {
    return new TeamPublicCache(from.id, from.data.updatedAt.toDate(), from.data.name, {
      ...DEFAULT_TEAM_PUBLIC_CACHE_SETTINGS,
      ...from.data.settings,
    });
  }
}
